import { useEffect, useState } from "react";

const NAV = [
  { label: "Release", href: "#release" },
  { label: "Archive", href: "#archive" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-700 ${
        scrolled
          ? "bg-[#080808]/85 backdrop-blur-md border-b border-[#141414]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 md:px-16 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-wordmark"
          className="kv-wordmark text-[#f2f0e9] text-sm sm:text-base"
          style={{ letterSpacing: "0.42em" }}
        >
          K · KACHEVSKY
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className="kv-overline kv-link"
            >
              {item.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="nav-cta"
          className="md:hidden kv-overline text-[#a3a3a3]"
        >
          Contact
        </a>
      </div>
    </header>
  );
};

export default Header;
